import BenthicPhotoQuadratForm from './BenthicPhotoQuadratForm'

export default BenthicPhotoQuadratForm
